import { selectCurrentPermissions } from "../store/users/selectors"
import { useAppSelector } from "../store/hooks"
import { Permission } from "../models/role"
import { INVERTED_PERMISSIONS_NO_ACCESS } from "../permissions"

export const isPermissionEnabled = (permission: string, currentPermissions: Permission[]) => {
    const foundPermission = currentPermissions.find(currentPermission => currentPermission.Name === permission)

    if (!foundPermission) {
        return INVERTED_PERMISSIONS_NO_ACCESS.has(permission)
    }

    if (INVERTED_PERMISSIONS_NO_ACCESS.has(permission)) {
        return !foundPermission.IsEnabled
    }

    return foundPermission.IsEnabled
}

function usePermissionsCheck(perms: string[], operation: "and" | "or" = "and") {
    const currentPerms = useAppSelector(selectCurrentPermissions)

    const hasPermission = (permission: string) => {
        return isPermissionEnabled(permission, Array.from(currentPerms))
    }

    return operation === "and" ? perms.every(hasPermission) : perms.some(hasPermission)
}

export default usePermissionsCheck
